/**
 * User
 */
export const SAVE_SEARCH_USERS = 'SAVE_SEARCH_USERS'
export const SAVE_USER = 'SAVE_USER'

/**
 * Feature Flags
 */
export const STORE_FEATURE_FLAGS = 'STORE_FEATURE_FLAGS'
